/**
 * Загрузка CSS
 */
export function loadCSS (url) {
  document.body.insertAdjacentHTML('beforeend', `<link rel='stylesheet' href='${url}'>`)
}
